import React, { useRef, useState } from 'react';
import { CalendarDays } from 'lucide-react';
import {
  PeriodModal,
  getCalendarBounds,
} from '../../equipment-consult/components/EquipmentConsultProductionPeriodPicker';
import '../../equipment-consult/components/EquipmentConsultProductionPeriodPicker.css';
import './PermDataInicialPanel.css';

const MIN_START_DATE = '2000-01-01';

const FIELDS = [
  {
    key: 'os_start_date',
    title: 'Data inicial de ordens de serviço',
    sub: 'A partir desta data o cliente visualiza suas ordens de serviço ao longo do contrato.',
  },
  {
    key: 'supply_order_start_date',
    title: 'Data inicial de pedido de suprimentos',
    sub: 'A partir desta data o cliente visualiza seus pedidos de suprimentos ao longo do contrato.',
  },
  {
    key: 'quality_rating_start_date',
    title: 'Data inicial para avaliações de qualidade',
    sub: 'A partir desta data o cliente visualiza suas avaliações de qualidade ao longo do contrato.',
  },
];

function formatDateBr(ymd) {
  if (!ymd) return '';
  const [y, m, d] = String(ymd).split('-');
  return y && m && d ? `${d}/${m}/${y}` : '';
}

function DateField({ field, value, busy, onSave }) {
  const btnRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [anchorRect, setAnchorRect] = useState(null);

  const togglePicker = () => {
    if (busy) return;
    setAnchorRect(btnRef.current?.getBoundingClientRect() || null);
    setOpen((v) => !v);
  };

  const save = async (next) => {
    if ((next || null) === (value || null)) return;
    await onSave?.(field.key, next || null);
  };

  return (
    <section className={`pct-card pdi-card${open ? ' is-open' : ''}`}>
      <h3 className="pct-card-title">{field.title}</h3>
      <p className="pct-card-sub">{field.sub}</p>
      <div className="pdi-trigger-row">
        <button
          ref={btnRef}
          type="button"
          className={`pdi-trigger${value ? ' has-value' : ''}`}
          onClick={togglePicker}
          disabled={busy}
          aria-expanded={open}
        >
          <CalendarDays size={14} strokeWidth={2} aria-hidden />
          <span>{value ? formatDateBr(value) : 'Todo o histórico'}</span>
        </button>
      </div>
      {open ? (
        <PeriodModal
          anchorRef={btnRef}
          anchorRect={anchorRect}
          currentPeriod={value ? { startDate: value, endDate: value } : null}
          minDate={MIN_START_DATE}
          maxDate={getCalendarBounds().maxDate}
          initialMonthDate={value || null}
          dayMode
          singleMonth
          hideHeader
          hideActionsBorder
          useUserFormActions
          modalClassName="ec-module-popover pdi-period-modal"
          zIndex={13100}
          title={field.title}
          onApply={(startDate) => save(startDate || null)}
          onClear={() => save(null)}
          onClose={() => setOpen(false)}
        />
      ) : null}
    </section>
  );
}

/** Aba "Data inicial de dados" — datas a partir das quais o cliente visualiza cada tipo de dado no portal. */
export default function PermDataInicialPanel({ values, busy = false, onSave }) {
  return (
    <div className="pct-dash pdi-root" aria-label="Data inicial de dados">
      <header className="pct-dash-head">
        <div>
          <h2 className="pct-dash-title">Data inicial de dados</h2>
          <p className="pct-dash-sub">
            Defina a partir de quando cada informação fica visível ao cliente no portal. Sem data, todo o histórico
            é exibido.
          </p>
        </div>
      </header>
      <div className="pdi-grid">
        {FIELDS.map((f) => (
          <DateField key={f.key} field={f} value={values?.[f.key] || null} busy={busy} onSave={onSave} />
        ))}
      </div>
    </div>
  );
}
